import axios from './axios';
import { EventUserRole } from '../types/models';

export const projectUserApi = {
  // Get all users associated with a project
  async getProjectUsers(projectId: number): Promise<number[]> {
    const response = await axios.get(`/user-projects/projects/${projectId}/users`);
    return response.data;
  },

  // Get all projects associated with a user
  async getUserProjects(userId: number): Promise<number[]> {
    const response = await axios.get(`/user-projects/users/${userId}/projects`);
    return response.data;
  },

  // Get user roles for a project
  async getProjectUserRoles(projectId: number): Promise<EventUserRole[]> {
    const response = await axios.get(`/projects/${projectId}/user-roles`);
    return response.data;
  }
};
